/** 계산 결과의 의미가 바뀌면 올린다. 저장한 실행 기록은 당시 버전을 보존한다. */
export const ENGINE_VERSION = "h2lca-core@0.2.0";

/** 기존 엔진의 물질수지 상대 허용오차. 1 kg 미만 흐름은 1 kg을 기준으로 한다. */
export const MASS_BALANCE_RELATIVE_TOLERANCE = 0.005;

/** 전력원 배분량과 설비 합계의 반올림 차이를 제외하는 수치 비교 오차. 제도 기준이 아니다. */
export const ELECTRICITY_RECONCILIATION_TOLERANCE = 0.000001;
